module.exports = __webpack_public_path__ + "img/pe-flag.4c800355.png";